<script>
import PackageReportWarehouse from './PackageReportWarehouse'

export default {
  name: 'PackageReportTenant',
  extends: PackageReportWarehouse,
  data () {
    return {
      headers: [
        { text: this.$t('index'), align: 'left', sortable: false, value: 'id' },
        { text: this.$t('warehouse'), align: 'left', sortable: false, value: 'title' },
        { text: this.$t('startDate'), align: 'left', sortable: true, value: 'startDate' },
        { text: this.$t('endDate'), align: 'left', sortable: true, value: 'endDate' },
        { text: this.$t('actions'), value: 'createTime', align: 'center', sortable: false, width: '10%' }
      ]
    }
  },
  methods: {
    getEntityId (item) {
      return this.warehouses.find(warehouse => warehouse.warehouseKey === item.warehouseKey)['warehouseName']
    },
    addReport () {
      let payload = {
        warehouseName: this.warehouseSelected.warehouseName,
        warehouseKey: this.warehouseSelected.warehouseKey,
        timeZoneOffset: new Date().getTimezoneOffset(),
        startDate: this.startDate,
        endDate: this.endDate
      }
      return this.$store.dispatch('addPackageReportTenant', payload)
    },
    deleteReport (item) {
      if (!confirm(this.$t('confirmDeleteReport'))) return Promise.resolve()
      return this.$store.dispatch('deletePackageReportTenant', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PackageReportTenant.vue